import { GET_OTROS_DATOS_CIERRE_SEMANAL, MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL } from '../constants/action_types';

const initialState = { otrosdatos: {}, isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_OTROS_DATOS_CIERRE_SEMANAL:

            return {
                otrosdatos: {},
                isLoading: true
            };

        case GET_OTROS_DATOS_CIERRE_SEMANAL + "_SUCCESS":

            return {
                otrosdatos: action.payload.data,
                isLoading: false
            };

        case MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL:

            return {
                otrosdatos: { ...state.otrosdatos, [action.payload.field]: action.payload.value },
                isLoading: false
            }


        default:

            return state;
    }
}